import React, { Fragment, useContext, useEffect } from 'react';

import {
    Paper,
    List,
    ListSubheader,
    ListItem,
    ListItemIcon,
    ListItemText,
    Typography    
} from '@material-ui/core';

import { TablesContext } from '../TablesContext';

import ListAltIcon from '@material-ui/icons/ListAltOutlined'

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
    root: {
    },
    notables: {
        padding: "16px"
    }
}));

export const TableList = (props) => {
    const classes = useStyles();

    const {
        state,        
        setSelectedTableIndex
    } = useContext(TablesContext);

    const itemSelectHandler = (e, index) => {
        setSelectedTableIndex(index);
    }

    return (
        <Fragment>
            {state.tables.length > 0 ?
                <Paper className={classes.root}>
                    <List subheader={<ListSubheader>All tables</ListSubheader>}>
                        {state.tables && state.tables.filter(table => table.name !== "AppSettings").map((table, index) => (
                            <ListItem button key={index} selected={state.selectedTableIndex === index}
                                onClick={(e, i) => itemSelectHandler(e, index)}>
                                <ListItemIcon>
                                    <ListAltIcon />
                                </ListItemIcon>
                                <ListItemText primary={table.name} />
                            </ListItem>
                        ))}
                    </List>
                </Paper>
                :
                <Paper className={classes.notables}>
                    <Typography variant="h6">
                        No tables available.
                    </Typography>
                    <Typography variant="body1">
                        There's no tables avaiable at this time.
                    </Typography>
                </Paper>
            }
        </Fragment>
    );
}